import React, { useState } from "react";
import Paginador from "./Paginador"; // Importa tu componente Paginador

const ProductTable = ({
  products,
  selectedProducts,
  setSelectedProducts,
  onSelectionChange,
}) => {
  // 1) Estados para la paginación
  const [itemsPerPage, setItemsPerPage] = useState(25); // Valor por defecto
  const [currentPage, setCurrentPage] = useState(1);

  // 2) Funciones para cambio de página
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // 3) Funciones para cambio de ítems por página
  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  // 4) Cálculo de paginación: rebanamos el array según la página
  const totalItems = products.length;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentProducts = products.slice(startIndex, endIndex);

  // 5) Manejo de checkboxes en la página actual
  const handleCheckboxChange = (productId) => {
    setSelectedProducts((prev) => {
      const updated = {
        ...prev,
        [productId]: !prev[productId],
      };
      onSelectionChange(updated);
      return updated;
    });
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    // Seleccionamos/desmarcamos solo los productos de la página actual
    const newSelected = currentProducts.reduce((acc, product) => {
      acc[product.id] = isChecked;
      return acc;
    }, {});
    setSelectedProducts(newSelected);
    onSelectionChange(newSelected);
  };

  return (
    <div className="cotizaciones-table">
      <div className="tabla-cotizaciones-wrapper">
        <div className="tabla-cotizaciones-content">
          {/* Tabla con los productos de la página actual */}
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      // Verificamos que todos en la página actual estén seleccionados
                      currentProducts.length > 0 &&
                      currentProducts.every((p) => selectedProducts[p.id])
                    }
                    className="checkbox-select-all"
                  />
                </th>
                <th></th>
                <th style={{ width: "30%", textAlign: "left" }}>Nombre</th>
                <th>Categoría</th>
                <th>Número Parte Proveedor</th>
                <th>Costo</th>
                <th>Proveedor</th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.map((product) => (
                <tr key={product.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={!!selectedProducts[product.id]}
                      onChange={() => handleCheckboxChange(product.id)}
                      className="checkbox"
                    />
                  </td>
                  <td>
                    <img
                      src={product.imagen}
                      alt={product.nombre}
                      className="tableProducts-image"
                    />
                  </td>
                  <td>
                    <span className="description-text">{product.nombre}</span>
                    <span className="model-text">
                      {" "}
                      (Modelo: {product.numeroDeParteCliente})
                    </span>
                  </td>
                  <td>{product.categoria || "Ninguna"}</td>
                  <td>{product.numeroDeParteProveedor}</td>
                  <td>
                    {parseFloat(product.costo)
                      .toFixed(2)
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>{product.proveedor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Footer con el paginador */}
        <div className="tabla-cotizaciones-footer">
          <div className="paginador-container">
            <Paginador
              totalItems={totalItems} // total de productos
              itemsPerPage={itemsPerPage} // items por página
              currentPage={currentPage} // página actual
              onPageChange={handlePageChange} // cambia página
              onItemsPerPageChange={handleItemsPerPageChange} // cambia # items/página
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTable;
